import React from 'react';
import { Box, Grid, Skeleton } from '@/shared/ui';

const FieldSkeleton: React.FC = () => (
  <Box>
    <Skeleton variant="text" width={96} height={16} sx={{ mb: 0.5 }} />
    <Skeleton variant="rounded" height={40} width="100%" />
  </Box>
);

/** Skeleton matching AppointmentForm two-pane layout. */
const AppointmentFormSkeleton: React.FC = () => (
  <Grid container spacing={3} alignItems="flex-start">
    <Grid size={{ xs: 12, md: 5 }}>
      <Skeleton variant="text" width={160} height={28} sx={{ mb: 1 }} />
      <Skeleton variant="rounded" height={280} width="100%" />
    </Grid>

    <Grid size={{ xs: 12, md: 7 }}>
      <Skeleton variant="text" width={180} height={28} sx={{ mb: 2 }} />
      <FieldSkeleton />

      <Skeleton variant="text" width={160} height={28} sx={{ mt: 3, mb: 2 }} />
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <FieldSkeleton />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <FieldSkeleton />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <FieldSkeleton />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <FieldSkeleton />
        </Grid>
        <Grid size={12}>
          <Skeleton variant="rounded" height={64} width="100%" />
        </Grid>
        <Grid size={12}>
          <Skeleton variant="rounded" height={96} width="100%" />
        </Grid>
      </Grid>
    </Grid>
  </Grid>
);

export default AppointmentFormSkeleton;
